export default {
    originFund: 'Fondo origen',
    destinationFund: 'Fondo destino',
    product: 'Producto',
    cancelModal: {
        title: 'Cancelar operación',
        confirmation: 'Esta acción cancelará la operación {{operation}}. ¿Desea continuar?',
        rdSentConfirmation: '¿Está seguro de que desea cancelar la operación {{operation}}?',
        rdSentWarning: 'La operación ya se ha enviado a la herramienta de administración. Si la cancela en Peakline, deberá cancelarla también en dicha herramienta.'
    },
    status: {
        REGISTERED_ONLINE: 'Pendiente',
        REGISTERED_EMAIL: 'Pendiente',
        REGISTERED_POSTAL: 'Pendiente',
        REGISTERED: 'Pendiente',
        SIGNED: 'Firmada',
        VALIDATED: 'Validada',
        RD_SENT: 'Enviada',
        PERIODIC_ACTIVE: 'Periódica Activa',
        CANCELLED: 'Anulada',
        FINALIZED: 'Finalizada',
        PERIODIC_SUSPENDED: 'Periódica suspendida',
        SOLICITUD_PENDIENTE_ENVIO_INTERCAMBIO: 'Solicitud Pendiente de Envío a Intercambio', // SNCE_1 Entrada
        SOLICITUD_ENVIADA_A_GESTORA_ORIGEN: 'Solicitud Enviada a Gestora Origen', // SNCE_2 Entrada
        RECIBIDO_RECHAZO: 'Rechazo Recibido', // SNCE_3 Entrada
        TRASPASO_RECIBIDO_PENDIENTE_VALORAR: 'Traspaso Recibido Pendiente Valorar', // SNCE_3 Entrada
        SOLICITUD_TRASPASO_SALIDA_PENDIENTE: 'Solicitud Traspaso de Salida Pendiente', // SNCE_1 Salida
        TRASPASO_SALIDA_GENERADO_PENDIENTE_VALORAR: 'Traspaso de Salida Generado Pendiente de Valorar', // SNCE_2 Salida
        ENVIADO_RECHAZO: 'Rechazo Enviado', // SNCE_3 Salida
        TRANSFERENCIA_ENVIADA: 'Transferencia Enviada'// SNCE_3 Salida
    },
    periodicity_options: {
        'MENSUAL': 'Mensual',
        'TRIMESTRAL': 'Trimestral',
        'SEMESTRAL': 'Semestral',
        'ANUAL': 'Anual'
    },
    revaluation_options: {
        'no-increase': 'Sin incremento',
        'LINEAL': 'Lineal',
        'PORCENTUAL': 'Porcentual',
        'ACUMULATIVO': 'Acumulativo'
    },
    amount_shares_indicator: {
        'I': 'Neto',
        'B': 'Efectivo',
        'P': 'Participaciones'
    },
    operations_types: {
        APORTACION: 'Aportación',
        APORTACION_PERIODICA: 'Aportación Periódica',
        BLOQUEO_PARTICIPACIONES: 'Bloqueo de participaciones',
        COMPRESION: 'Compresión',
        CONTINGENCIA_ENTRADA: 'Entrada de Saldo por Contingencia',
        CONTINGENCIA_SALIDA: 'Salida de Saldo por Contingencia',
        DESBLOQUEO_PARTICIPACIONES: 'Desbloqueo de participaciones',
        DIVIDENDO: 'Dividendo',
        DONACION_ENTRADA: 'Donación de Entrada',
        DONACION_SALIDA: 'Donación de Salida',
        HERENCIA_ENTRADA: 'Herencia de Entrada',
        HERENCIA_SALIDA: 'Herencia de Salida',
        REEMBOLSO: 'Reembolso',
        REEMBOLSO_PARTICIPACIONES: 'Reembolso de participaciones',
        REEMBOLSO_PERIODICO: 'Reembolso Periódico',
        RESCATE: 'Rescate',
        SOLICITUD_APORTACION_PERIODICA: 'Solicitud de Aportación Periódica',
        SOLICITUD_REEMBOLSO: 'Solicitud de Reembolso',
        SOLICITUD_REEMBOLSO_PERIODICO: 'Solicitud de Reembolso Periódico',
        SOLICITUD_SUSCRIPCION: 'Solicitud de Suscripción',
        SOLICITUD_SUSCRIPCION_PERIODICA: 'Solicitud de Suscripción Periódica',
        SOLICITUD_TRASPASO_EXTERNO_ENTRADA: 'Solicitud Traspaso Externo de Entrada',
        SOLICITUD_TRASPASO_EXTERNO_SALIDA: 'Solicitud Traspaso Externo de Salida',
        SOLICITUD_TRASPASO_INTERNO: 'Solicitud Traspaso Interno',
        SPLIT: 'Split',
        SUSCRIPCION: 'Suscripción',
        SUSCRIPCION_PARTICIPACIONES: 'Suscripción de participaciones',
        SUSCRIPCION_PERIODICA: 'Suscripción Periódica',
        TRASPASO_ENTRADA: 'Traspaso de Entrada',
        TRASPASO_SALIDA: 'Traspaso de Salida',
        DEVOLUCION_EXCESO: 'DEvolución de exceso'
    },
    operations_sub_types:{
        TC: 'Traspaso de clase',
        B: 'Bloqueo Manual',
        P: 'Pignoración | Herencia Pago Gananciales | Prestación',
        I: 'Traspaso Interno',
        E: 'Traspaso Externo',
        S: 'Canje',
        R: 'Separación de bienes',
        C: 'Capitulación',
        T: 'Cambio Titularidad',
        O: 'Cambio Comercializador | Otros',
        N: 'Testamentaría',
        D: 'Disolución',
        L: 'Disolución Sociedad Gananciales',
        F: 'Fusión',
        H: 'Herencia',
        G: 'Renta Obligatoria',
        V: 'Prestaciones con Reversión',
        A: 'Actuarial',
        J: 'Baja',
        AP: 'Aportación con Prestación'
    },
    indicators: {
        I: 'Importe neto',
        B: 'Importe bruto',
        P: 'Participaciones'
    },
    source_situations: {
        PARTICIPE: 'Participe - derechos consolidados',
        BENEFICIARIO: 'Beneficiario - derechos económicos'
    },
    compartments: {
        '1': 'Anteriores a 2007',
        '2': 'Posteriores a 2006',
        '3': 'De ambos'
    },
    redemption_defers: {
        'DIFERIDO': 'Diferido',
        'NO_DIFERIDO': 'No diferido'
    },
    redemption_collection_methods: {
        TOTAL: 'Totalidad del capital',
        MIXTA: 'Renta Mixta',
        FINANCIERA: 'Renta financiera',
        OTRAS: 'Otras'
    },
    redemption_causes: {
        JUBILACION: 'Jubilación',
        INVALIDEZ: 'Invalidez',
        DEPENDENCIA: 'Dependencia',
        ENFERMEDAD_GRAVE: 'Enfermedad grave',
        DESEMPLEO: 'Desempleo',
        VARIACION_PRESTACION: 'Variación prestación',
        FALLECIMIENTO: 'Fallecimiento'
    },
    rights_types: {
        'C': 'Derechos consolidados',
        'E': 'Derechos económicos',
        'A': 'Ambos'
    },
    pay_methods: {
        'DOMICILIACION': 'Domiciliacion',
        'TRANSFERENCIA': 'Transferencia',
        'CHEQUE': 'Cheque',
        'OMF': 'OMF'
    },
    rendering_variation_types: {
        'INCREMENTO_RENTA': 'Incremento de la renta',
        'DISMINUCION_RENTA': 'Disminución de la renta',
        'ADELANTO_COBRO': 'Adelanto del cobro de capital'
    },
    reconciliation_statuses: {
        PRECONCILIADO: 'Preconciliado',
        CONCILIADO: 'Conciliado',
        AGRUPADO: 'Agrupado',
        'PRECONCILIADO PIP': 'Preconciliado PIP'
    },
    purchase_key_operation_type: {
        APORTACION: 'Aportación',
        SUSCRIPCION: 'Suscripción',
        HERENCIA_ENTRADA: 'Herencia',
        DONACION_ENTRADA: 'Donación',
        TRASPASO_ENTRADA: 'Traspaso'
    },
    tx_collection_methods: {
        1: 'Todas las formas de cobro',
        2: 'Capital diferido',
        3: 'Renta financiera',
        4: 'Pagos sin periocidad regular'
    },
    ind_percepcion_pres: {
        C: 'Capital',
        R: 'Renta',
        M: 'Mixto',
        O: 'Otros'
    },
    ind_tipo_pres: {
        C: 'Capital Inmediato',
        D: 'Capital Diferido',
        A: 'Renta Asegurada Inmediata',
        R: 'Renta Asegurada Diferida',
        F: 'Renta Financiera Inmediata',
        N: 'Renta Financiera Diferida',
        V: 'Renta Vitalicia'
    },
    warnings : {
        pendingTotalRedemption: 'Existe una solicitud de reembolso total pendiente para este fondo. No se pueden realizar nuevos reembolsos (totales o parciales) hasta que dicha operación haya sido finalizada o cancelada.',
        attention: '¡Atención!',
        vl_medium: 'VL de compra medio: es el resultante de dividir el coste de adquisición de las participaciones que mantiene entre el número de participaciones'
    },
    aml_flags: {
        is_pep: 'Persona políticamente expuesta',
        was_pep: 'Fue persona políticamente expuesta',
        is_sanctioned: 'En listas de sanciones internacionales',
        was_sanctioned: 'Estuvo en listas de sanciones internacionales',
        is_terrorist: 'Relacionado con terrorismo',
        has_media: 'Presencia en medios',
        has_advertense_info: 'Información adversa',
        is_high_risk: 'Riesgo elevado según proveedor PBC',
        has_matches: 'Coincidencias con bases de datos PBC',
        high: 'Alto',
        medium: 'Medio',
        aml_risk: 'Alerta PBC'
    },
    form : {
        managementCompany: 'Gestora',
        managerMarketer: 'Gestora/Comercializador',
        marketer: 'Comercializador',
    }
};
